// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"auth_wrapper__YsR3d","header":"auth_header__3I8et","content":"auth_content__vfPms"};